var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTroncoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_106681",
    "data-name": "Group 106681",
    transform: "translate(-22 -668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49474",
    "data-name": "Path 49474",
    d: "M22,0A22,22,0,1,1,0,22,22,22,0,0,1,22,0Z",
    transform: "translate(22 668)",
    fill: "#ff060a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tron",
    transform: "translate(31.35 680)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49472",
    "data-name": "Path 49472",
    d: "M24.05,7.23C22.925,6.191,21.369,4.6,20.1,3.48l-.075-.053a1.433,1.433,0,0,0-.416-.233h0C16.554,2.625,2.33-.034,2.053,0a.525.525,0,0,0-.218.083L1.764.138a.836.836,0,0,0-.2.315L1.55.5V.809c1.6,4.459,7.924,19.065,9.169,22.493.075.233.218.675.484.7h.06c.143,0,.75-.8.75-.8s10.86-13.17,11.959-14.573a3.547,3.547,0,0,0,.375-.555A.9.9,0,0,0,24.05,7.23ZM14.8,8.763,19.434,4.92l2.719,2.505ZM13,8.512l-7.98-6.54L17.93,4.353Zm.72,1.714L21.887,8.91,12.549,20.16Zm-9.784-7.6,8.4,7.125L11.116,20.167Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroncoin);
export default __webpack_public_path__ + "static/media/troncoin.0450bc1e0db4ba6d5c08d31d17a354fb.svg";
export { ForwardRef as ReactComponent };